export enum PublipostageModelesPath {
  EDITION_COURRIER_PARAM_NAME = 'idModele',
  LISTE_MODELES = '',
  EDITION_MAIL = 'edition-publipostage-modele',
  EDITION_COURRIER = 'creation-publipostage-modele-courrier',
  CREATION_MAIL = 'creation-publipostage-modele-mail',
  CREATION_COURRIER = 'creation-publipostage-modele-courrier',
  ID_PUBLIPOSTAGE_MODELE_PARAM_MAP = 'idPublipostageModele',
}
